<script setup>
	import ReactivateIcon from "./ReactivateIcon.vue";
	import { VBtn } from "vuetify/components";

	const props = defineProps({
		class: Array,
		disabled: Boolean
	});
	const emit = defineEmits([ "click" ]);

	function raiseClickEmit() {
		emit("click");
	}
</script>

<template>
	<VBtn title="Reactivate"
		:class="props.class.concat(['mx-2', 'reactivate-action'])"
		:disabled="props.disabled"
		@click="raiseClickEmit">
		<ReactivateIcon/>
	</VBtn>
</template>
